import { FiltrosReceberRecebidas } from './../receber-recebidas/filtros-receber-recebidas';
import { ConsultasService } from '@app/services/consultas.service';
import { RelatorioService } from '@app/services/relatorio.service';
import { UtilitarioService } from '@app/services/utilitario.service';
import { ToastrService } from 'ngx-toastr';
import { IdDescricao } from '@app/models/util/id-descricao';
import debounce from '@app/utils/debounce';
import { Component, Inject, OnInit } from '@angular/core';

@Component({
  selector: 'app-acordo-trabalhista',
  templateUrl: './acordo-trabalhista.component.html'
})
export class AcordoTrabalhistaComponent implements OnInit {

  filtros: FiltrosReceberRecebidas = new FiltrosReceberRecebidas();
  lstParticipante: Array<any> = [{}];
  lstUnidades: IdDescricao[];
  pesquisando: boolean = false;

  totalBruto: number = 0;
  totalLiquido: number = 0;

  nomeParticipanteRelatorio: string = "";

  relatorioAcordo: any = [];
  emissao: Date;

  _debounce: any;
  _pesquisa: any;

  constructor(
    private consultasService: ConsultasService,
    private relatorioService: RelatorioService,
    @Inject(ToastrService) public toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.filtros.TipoData = 'Vencimento';
    this.filtros.UnidadeId = 0;
    this.filtros.DataInicial = UtilitarioService.retornaDataAtualMaisDiasISO(0);
    this.filtros.DataFinal = UtilitarioService.retornaDataAtualMaisDiasISO(7);
    this.consultasService.consultar('UNIDADE_S_RATEIO').toPromise().then(data => this.lstUnidades = data);
  }

  pesquisar() {
    this.emissao = new Date();
    this.pesquisando = true;
    this.relatorioService.acordoTrabalhista(this.filtros).subscribe(
      (data) => {
        this.totalLiquido = 0;
        this.totalBruto = 0;
        if(data.length === 0)
          this.toastr.info('Busca não encontrou resultados!');
        else{
          this.relatorioAcordo = data;
          data.forEach(item => {
            this.totalLiquido += item.ValorLiquidoEscritorio;
            this.totalBruto += item.Valor;
          });
        }
        this.pesquisando = false;
      },
      (error) => { 
        this.toastr.error('Erro ao buscar, tente novamente!');
        this.pesquisando = false;
      }
    );

  }

  imprimir(){
    let conteudo = document.getElementById("relatorioAcordoTrabalhista").innerHTML;
    UtilitarioService.imprimirHTML(conteudo, "Relatório Acordo Trabalhista", this.montaImpressaoFiltros());
  }

  private montaImpressaoFiltros(){
    let objetoFiltros = new Map<string, string>();

    objetoFiltros.set('Emitido em', this.emissao.toLocaleString());
    
    adicionaMapValido("Tipo de Data", this.filtros.TipoData);

    parseDateAdicionaMap('Data Inicial', this.filtros.DataInicial);
    parseDateAdicionaMap('Data Final', this.filtros.DataFinal);    

    obtemDescricaoAdicionaMap('Unidade', this.lstUnidades, this.filtros.UnidadeId);
    adicionaMapValido('Cliente', this.nomeParticipanteRelatorio);

    
    function obtemDescricaoAdicionaMap(chave: string, listaItens: IdDescricao[], idItem: number){
      if(idItem){
        let valor = listaItens.find(x => x.Id === idItem).Descricao;
        objetoFiltros.set(chave, valor);
      } 
    }

    function parseDateAdicionaMap(tipoData: string, data: string){
      if(data && data.indexOf('-') >= 0){
        let dataPartes = data.split('-');
        let dataMontada = dataPartes[2] + '/' + dataPartes[1] + '/' + dataPartes[0];
        objetoFiltros.set(tipoData, dataMontada);
      }
    }

    function adicionaMapValido(chave: string, valor: any){
      if(valor){
        objetoFiltros.set(chave, valor.toString());
      }
    }

    let stringHtml = '';

    objetoFiltros.forEach((valor, chave) => {
      stringHtml += `<tr><td>${chave}</td><td>${valor}</td></tr>`;
    })
    return stringHtml;
  }

}
